import { createAsyncThunk } from "@reduxjs/toolkit";

import { FETCH_UPLOADS_IN_BATCH } from "../../queries";

import { REDUCERS } from "../../constants";

import { apolloClient } from "js/apollo/apollo-client";

import { initializeUploadFooterActions } from "../uploadFooterActionsSlice";
import { batchesSlice } from "../batchesSlice";

export const fetchUploadsInBatch = createAsyncThunk(
    `${REDUCERS.UPLOADS}/fetchUploadsInBatch`,
    async (batchId, { dispatch, getState }) => {
        const { data } = await apolloClient.query({
            query: FETCH_UPLOADS_IN_BATCH,
            variables: {
                batchId
            },
            fetchPolicy: "network-only"
        });

        const uploads = data.list.items;
        const { isPremiumPhotographer } = getState().batches.entities[
            batchId
        ].creator;
        const processedUploads = uploads.map(upload => ({
            ...upload,
            creatorIsPremium: isPremiumPhotographer
        }));

        dispatch(initializeUploadFooterActions(processedUploads));

        dispatch(
            batchesSlice.actions.updateOne({
                id: batchId,
                changes: {
                    uploadsFetched: true
                }
            })
        );

        return processedUploads;
    }
);
